import { useEffect, useState } from "react";
import { Cookie } from "lucide-react";
import {
  CONSENT_EVENT, OPEN_SETTINGS_EVENT, loadClarity, readConsent, revokeClarity, saveConsent,
} from "@/lib/clarity";

export const CookieConsent = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const saved = readConsent();
    if (saved?.statistics) loadClarity();
    if (!saved) setOpen(true);

    const onChange = (e) => (e.detail?.statistics ? loadClarity() : revokeClarity());
    const onOpen = () => setOpen(true);
    window.addEventListener(CONSENT_EVENT, onChange);
    window.addEventListener(OPEN_SETTINGS_EVENT, onOpen);
    return () => {
      window.removeEventListener(CONSENT_EVENT, onChange);
      window.removeEventListener(OPEN_SETTINGS_EVENT, onOpen);
    };
  }, []);

  const choose = (statistics) => {
    saveConsent(statistics);
    setOpen(false);
  };

  if (!open) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie-inställningar"
      data-testid="cookie-banner"
      className="fixed z-[45] left-3 right-3 bottom-[84px] md:left-6 md:right-auto md:bottom-6 md:w-[420px] bg-[#0B132B] text-white border-2 border-white/20 border-l-4 border-l-[#D92525] shadow-2xl p-5"
    >
      <div className="flex items-start gap-3">
        <Cookie size={20} className="text-[#D92525] shrink-0 mt-0.5" />
        <div className="min-w-0">
          <div className="font-display font-black text-sm tracking-tight">Cookies på swedcro.se</div>
          <p className="font-body text-xs text-white/75 mt-1.5 leading-relaxed">
            Vi använder nödvändiga cookies för att sidan ska fungera. Med ditt samtycke använder vi även
            statistikcookies (Microsoft Clarity) för att förstå hur besökare använder sidan och vilka
            tjänster som intresserar mest. Du kan ändra ditt val när som helst via "Cookie-inställningar" i sidfoten.{" "}
            <a href="/integritetspolicy" data-testid="cookie-privacy-link" className="text-[#FFB3B3] hover:text-white underline underline-offset-2">
              Läs vår integritetspolicy
            </a>
          </p>
        </div>
      </div>
      <div className="mt-4 flex flex-col sm:flex-row gap-2">
        <button
          type="button"
          onClick={() => choose(true)}
          data-testid="cookie-accept-stats"
          className="flex-1 bg-[#D92525] border-2 border-[#D92525] text-white font-display font-bold text-xs tracking-[0.15em] uppercase px-4 py-3 hover:bg-white hover:text-[#0B132B] transition-colors"
        >
          Acceptera statistik
        </button>
        <button
          type="button"
          onClick={() => choose(false)}
          data-testid="cookie-reject-stats"
          className="flex-1 border-2 border-white/60 text-white font-display font-bold text-xs tracking-[0.15em] uppercase px-4 py-3 hover:bg-white hover:text-[#0B132B] transition-colors"
        >
          Endast nödvändiga
        </button>
      </div>
    </div>
  );
};
